import { SERVICE_TYPE, AVAILABLE_LANGS } from "@typings/globals";

import { SendEvent } from "@hooks/useTelemetry";

export enum FIELD {
  SERVICE = "service",
  ZIPCODE = "zip-code",
  COVERED = "covered",
}

export interface FormValues {
  [FIELD.SERVICE]: SERVICE_TYPE;
  [FIELD.ZIPCODE]: string;
  [FIELD.COVERED]: boolean;
}

export type ShowUncoveredModal = (
  serviceType: SERVICE_TYPE,
  zipCode: string,
) => void;

export interface CoverageResponse {
  zip: string;
  city: string;
  serviceTypes?: SERVICE_TYPE[];
  hideCityName: boolean;
}

export interface FetchCoverageProps {
  zipCode: string;
}

export interface GetCoverageProps extends FetchCoverageProps {
  serviceType: SERVICE_TYPE;
  showUncoveredModal: ShowUncoveredModal;
}

export interface SubmitHandlerProps {
  language: AVAILABLE_LANGS;
  isSSG?: boolean;
  showUncoveredModal: ShowUncoveredModal;
  showFullyBookedEotModal: () => void;
  sendEvent: SendEvent;
  onSuccess: (url: string) => void;
}

export interface ServiceSelectorProps {
  language: AVAILABLE_LANGS;
  selectedService?: SERVICE_TYPE;
  defaultService?: SERVICE_TYPE;
  defaultZipCode?: string;
  isSSG?: boolean;
  onSuccess: (url: string) => void;
}
